/*
 * Okno wyszukiwania — warstwa UX ponad predictive-search.js z Dawna:
 *  - „Ostatnio szukane” w localStorage (max 6), chip wpisuje frazę do pola
 *    i od razu odpala podpowiedzi; „x” usuwa jedną, „Wyczyść” wszystkie;
 *  - zapamiętujemy frazę przy wysłaniu formularza i przy kliknięciu wyniku;
 *  - podświetlamy wpisaną frazę w tytułach produktów (po każdym renderze);
 *  - klasa `szukaj--tekst` na karcie, gdy pole ma tekst (CSS chowa start);
 *  - klik w puste miejsce panelu wraca fokusem do pola.
 * Markup: snippets/header-search.liquid, style: assets/custom-szukaj.css.
 */
(function () {
  var KLUCZ = 'dl_szukane';
  var MAX = 6;

  function czytaj() {
    try {
      var d = JSON.parse(localStorage.getItem(KLUCZ) || '[]');
      return Array.isArray(d) ? d.filter(function (x) { return typeof x === 'string' && x.trim(); }) : [];
    } catch (e) {
      return [];
    }
  }

  function zapisz(lista) {
    try {
      localStorage.setItem(KLUCZ, JSON.stringify(lista.slice(0, MAX)));
    } catch (e) {
      /* prywatne okno / brak miejsca — trudno */
    }
  }

  function dodaj(fraza) {
    fraza = (fraza || '').trim();
    if (fraza.length < 2) return;
    var lista = czytaj().filter(function (x) { return x.toLowerCase() !== fraza.toLowerCase(); });
    lista.unshift(fraza);
    zapisz(lista);
    document.querySelectorAll('[data-szukaj]').forEach(rysujOstatnie);
  }

  function usun(fraza) {
    zapisz(czytaj().filter(function (x) { return x !== fraza; }));
    document.querySelectorAll('[data-szukaj]').forEach(rysujOstatnie);
  }

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function rysujOstatnie(karta) {
    var blok = karta.querySelector('[data-szukaj-ostatnie]');
    var lista = karta.querySelector('[data-szukaj-ostatnie-lista]');
    if (!blok || !lista) return;
    var frazy = czytaj();
    blok.hidden = frazy.length === 0;
    lista.innerHTML = frazy
      .map(function (f) {
        return (
          '<li><span class="szukaj__chip szukaj__chip--ostatnie" role="button" tabindex="0" data-szukaj-fraza="' +
          escapeHtml(f) +
          '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>' +
          '<span>' + escapeHtml(f) + '</span>' +
          '<button type="button" class="szukaj__chip-usun" data-szukaj-usun="' + escapeHtml(f) + '" aria-label="Usuń „' + escapeHtml(f) + '” z ostatnio szukanych">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg>' +
          '</button></span></li>'
        );
      })
      .join('');
  }

  function podswietl(karta, fraza) {
    fraza = (fraza || '').trim();
    var slowa = fraza.split(/\s+/).filter(function (s) { return s.length >= 2; });
    karta.querySelectorAll('[data-szukaj-tytul]').forEach(function (el) {
      var tekst = el.textContent;
      if (!slowa.length) {
        el.textContent = tekst;
        return;
      }
      var re = new RegExp('(' + slowa.map(escapeRegExp).join('|') + ')', 'gi');
      el.innerHTML = escapeHtml(tekst).replace(re, '<mark>$1</mark>');
    });
  }

  function init(karta) {
    var input = karta.querySelector('input[type="search"]');
    var form = karta.querySelector('form');
    var panel = karta.querySelector('[data-szukaj-panel]');
    var wyniki = karta.querySelector('[data-predictive-search]');
    if (!input || !form) return;

    rysujOstatnie(karta);

    function odswiezStan() {
      karta.classList.toggle('szukaj--tekst', input.value.trim().length > 0);
    }
    input.addEventListener('input', odswiezStan);
    form.addEventListener('reset', function () {
      setTimeout(odswiezStan, 0);
    });
    odswiezStan();

    // Wysłanie formularza (Enter / „Szukaj „fraza””) — zapamiętaj
    form.addEventListener('submit', function () {
      dodaj(input.value);
    });

    // Klik w wynik (produkt, kolekcja, strona) — też zapamiętaj frazę
    karta.addEventListener('click', function (e) {
      var link = e.target.closest('.predictive-search__item[href]');
      if (link) dodaj(input.value);
    });

    // Chipy „ostatnio szukane”: wpisz i szukaj; „x” usuwa
    karta.addEventListener('click', function (e) {
      var usunBtn = e.target.closest('[data-szukaj-usun]');
      if (usunBtn) {
        e.preventDefault();
        e.stopPropagation();
        usun(usunBtn.getAttribute('data-szukaj-usun'));
        input.focus();
        return;
      }
      var chip = e.target.closest('[data-szukaj-fraza]');
      if (chip) {
        e.preventDefault();
        ustawFraze(chip.getAttribute('data-szukaj-fraza'));
      }
    });
    karta.addEventListener('keydown', function (e) {
      var chip = e.target.closest && e.target.closest('[data-szukaj-fraza]');
      if (chip && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        ustawFraze(chip.getAttribute('data-szukaj-fraza'));
      }
    });

    function ustawFraze(fraza) {
      input.value = fraza;
      input.focus();
      // predictive-search.js nasłuchuje 'input' (z debounce 300 ms)
      input.dispatchEvent(new Event('input', { bubbles: true }));
      odswiezStan();
    }

    // Klik w puste miejsce panelu → fokus wraca do pola (żeby nie „gasły” wyniki)
    if (panel) {
      panel.addEventListener('mousedown', function (e) {
        if (e.target === panel || e.target === wyniki || e.target.closest('[data-szukaj-start]') === e.target) {
          e.preventDefault();
          input.focus();
        }
      });
    }

    // Podświetlanie frazy po każdym renderze wyników
    if (wyniki && window.MutationObserver) {
      new MutationObserver(function () {
        podswietl(karta, input.value);
      }).observe(wyniki, { childList: true });
    }
  }

  function start() {
    document.querySelectorAll('[data-szukaj]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
